import React, {createContext, useContext} from 'react';
import {useLocation} from 'react-router-dom';
import PropTypes from 'prop-types';
import {shallowEqual, useSelector} from 'react-redux';
import {
  useCitiesContext,
  useStreetsContext
} from '../../_common/components/CitiesAndStreets';

const OrderDetailsUIGlobalContext = createContext('');

export function useOrderDetailsUIGlobalContext() {
  return useContext(OrderDetailsUIGlobalContext);
}

export function OrderDetailsUIGlobalProvider({children}) {
  const location = useLocation();

  const {users} = useSelector(
    (state) => ({users: state.usersReducer.users}),
    shallowEqual
  );
  const {cities} = useCitiesContext();
  const {streets} = useStreetsContext();

  const getOrderID = () => {
    const pathName = location.pathname;
    const orderNumber = pathName.replace('/order-details/', '');

    return orderNumber === '-1' ? -1 : parseInt(orderNumber, 10);
  };
  const orderID = getOrderID();

  const value = {
    orderID,
    users,
    cities,
    streets,
  };

  return (
    <OrderDetailsUIGlobalContext.Provider value={value}>
      {children}
    </OrderDetailsUIGlobalContext.Provider>
  );
}

OrderDetailsUIGlobalProvider.propTypes = {
  children: PropTypes.node,
};
